export default "__VITE_ASSET__BHTAMCzh__"